import React, { useEffect, useState } from 'react'
import { TypingWrapper, Cursor } from './styles'

const TypingTitle = () => {
  const [text, setText] = useState('')
  const [wordIndex, setWordIndex] = useState(0)
  const [letterIndex, setLetterIndex] = useState(0)
  const [isDeleting, setIsDeleting] = useState(false)

  const words = [
    'eficiencia',
    'rapidez',
    'precisión',
    'resultados',
    'agilidad',
    'soluciones reales',
  ]

  useEffect(() => {
    const currentWord = words[wordIndex]
    let typingSpeed = isDeleting ? 40 : 100

    const timer = setTimeout(() => {
      if (isDeleting) {
        setText(currentWord.substring(0, letterIndex - 1))
        setLetterIndex(letterIndex - 1)
      } else {
        setText(currentWord.substring(0, letterIndex + 1))
        setLetterIndex(letterIndex + 1)
      }

      if (!isDeleting && letterIndex === currentWord.length) {
        setTimeout(() => setIsDeleting(true), 1000)
      } else if (isDeleting && letterIndex === 0) {
        setIsDeleting(false)
        setWordIndex((prev) => (prev + 1) % words.length)
      }
    }, typingSpeed)

    return () => clearTimeout(timer)
  }, [letterIndex, isDeleting, wordIndex])

  return (
    <TypingWrapper>
      Tu tiempo merece <span>{text}</span>
      <Cursor>|</Cursor>
    </TypingWrapper>
  )
}

export default TypingTitle
